import React from 'react';
import { takeEvery, put, call } from 'redux-saga/effects';
import { FormattedMessage } from 'react-intl';
import { setRequestAccessRequests } from 'Workspace/Admin/store/actions';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { status } = action;
  const response = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_IAM_ACCESS_REQUEST_LIST,
    accessRequestStatus: status,
  });
  if (response.type === constants.RTM_IAM_ACCESS_REQUEST_LIST_OK) {
    const requests = response.response?.accessRequests || response.response?.requests || [];
    yield put(setRequestAccessRequests(requests, status));
  } else {
    yield put(
      pushToast({
        type: 'simple',
        message: <FormattedMessage {...messages.failedIamAccessRequestList} />,
      })
    );
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_IAM_ACCESS_REQUEST_LIST, catchErrors, sendRequest, connection);
}
